import { FormControl, Input, MenuItem, Select } from '@material-ui/core';
import { Map } from 'immutable';
import * as React from 'react';

const white = '#ffffff';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { EmailAddress } from 'shared/types/email-compose';

import { State } from '../../state';
import { fetchAccounts } from '../actions';

interface OwnProps {
    pagePath: string;
    selected: string;
}

interface ConnectedProps {
    accounts: Map<string, EmailAddress>;
}

interface ConnectedDispatch {
    fetchAccounts: () => void;
}

interface EmailAccountSelectorState {
    selectAccount: string;
    redirect: boolean;
}

type EmailAccountSelectorProps = OwnProps & ConnectedProps & ConnectedDispatch;

class EmailAccountSelectorComponent extends React.Component<EmailAccountSelectorProps, EmailAccountSelectorState> {
    constructor(props: EmailAccountSelectorProps) {
        super(props);
        if (!props.accounts) {
            props.fetchAccounts();
        }
        this.state = { selectAccount: null, redirect: false };
    }

    componentDidUpdate() {
        if (this.state.redirect) {
            this.setState({ selectAccount: null, redirect: false });
        }
    }

    handleAccountSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
        const account = event.target.value as string;
        if (this.props.selected !== account) {
            this.setState({ selectAccount: account, redirect: true });
        }
    };

    render() {
        const { pagePath } = this.props;
        const { selectAccount, redirect } = this.state;
        if (selectAccount && redirect) {
            return <Redirect to={`/${pagePath}/${selectAccount}/`} push={true} />;
        }
        const { accounts, selected } = this.props;
        if (!accounts) return null;
        const sortedAccounts = accounts
            .sortBy(
                (a) => a,
                (a1, a2) => a1.name.localeCompare(a2.name) || a1.address.localeCompare(a2.address)
            )
            .valueSeq()
            .toArray();
        const renderAccountOption = (account: EmailAddress) => {
            const label = `${account.name} <${account.address}>`;
            return (
                <MenuItem value={account.address} key={account.address}>
                    {label}
                </MenuItem>
            );
        };
        const menuItems = sortedAccounts.map(renderAccountOption);
        const renderSelectedAccount = (value: string) => {
            const account = accounts.get(value);
            return account ? `${account.name} <${account.address}>` : '';
        };
        const renderSelectedAccountValue = (value: unknown) => (
            <span style={{ color: white }}>{renderSelectedAccount(value as string)}</span>
        );
        return (
            <div className="email-inbox-account-info">
                <FormControl>
                    <Select
                        value={selected}
                        onChange={this.handleAccountSelect}
                        autoWidth={true}
                        input={<Input disableUnderline={true} />}
                        renderValue={renderSelectedAccountValue}
                    >
                        {menuItems}
                    </Select>
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state: State): ConnectedProps => ({
    accounts: state.emailInboxAccounts
});

const mapDispatchToProps: { [action in keyof ConnectedDispatch]: ConnectedDispatch[action] } = {
    fetchAccounts
};

export const EmailAccountSelector = connect<ConnectedProps, ConnectedDispatch, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(EmailAccountSelectorComponent);
